import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { isFunction } from 'intact-shared';
export function useList() {
  var instance = useInstance();
  var value = useState(instance.get('value'));
  var list = useState([]);
  function generateList() {
    var _instance$get = instance.get(),
      data = _instance$get.data,
      count = _instance$get.count;
    if (isFunction(data)) {
      data = data(value.value);
    }
    var index = _findIndexInstanceProperty(data).call(data, function (item) {
      return item.value === value.value;
    });
    if (index < 0) {
      index = 0;
      setValue(data[0].value, false);
    }
    var length = data.length;
    var half = Math.floor(count / 2);
    var _list = [];
    for (var i = 0; i < count; i++) {
      _list.push(data[((index - half + i) % length + length) % length]);
    }
    list.set(_list);
  }
  function setValue(v, generate) {
    var oldValue = value.value;
    value.set(v);
    if (oldValue !== v) {
      updateValue(v, generate);
    }
  }
  function updateValue(v, generate) {
    var _instance$get2 = instance.get(),
      disable = _instance$get2.disable;
    if (!disable || !disable(v)) {
      instance.set('value', v);
    }
    if (generate) {
      generateList();
    }
  }
  instance.on('$receive:value', function (v) {
    return setValue(v, true);
  });
  ['data', 'count'].forEach(function (item) {
    instance.on("$receive:" + item, generateList);
  });
  instance.on('$receive:disable', function () {
    var oldValue = instance.get('value');
    var _value = value.value;
    if (_value !== oldValue) {
      updateValue(_value, true);
    }
  });
  return {
    value: value,
    data: list,
    setValue: setValue
  };
}